module.exports = "<div class=\"scrollable next-wrapper\" *ngIf=\"bIsPageLoading\">\n  <div class=\"scrollable-content\">\n    <div class=\"list-group text-center\"> \n      <div class=\"list-group-item-home\">\n        <div class=\"next-body\" #bodyElement>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/next/next.component.html
// module id = ../../../../../src/app/next/next.component.html
// module chunks = main